import {connect} from '../../../app/connect';
import IssueTypesAdmin from './IssueTypesAdmin';
import {
  fetchIssuesCustomizationMetadata,
  updateIssueTypeStatusAction,
  trackEvent,
  selectIssueTypeForEdit,
  showIssueTypesEditModalAction,
  showIssueTypesAddAttributesModalAction,
  showIssueTypesLeaveAddAttributesModalAction,
  changeLocationAction,
  updateRequiredFields
} from '../../../app/actions';
import {
  getIssueTypesAdminEntitiesMap,
  isErrorLoadingIssueTypesAdminList,
  getFieldAdminPageDataLoading,
  isErrorLoadingIssueAttributesDefinitions,
  isErrorLoadingIssueAttributesMappings
} from '../../../app/selectors';
import featureFlags, {FEATURE_FLAGS} from '../../../utils/featureFlags';

const mapStateToProps = state => ({
  data: getIssueTypesAdminEntitiesMap(state),
  isLoading: getFieldAdminPageDataLoading(state),
  error:
    isErrorLoadingIssueTypesAdminList(state) ||
    isErrorLoadingIssueAttributesDefinitions(state) ||
    isErrorLoadingIssueAttributesMappings(state),
  ffShowDisableTemplatesModal: featureFlags.get(FEATURE_FLAGS.SHOW_DISABLE_TEMPLATES_MODAL)
});

const mapDispatchToProps = {
  changeLocationAction,
  fetchIssuesCustomizationMetadata,
  updateIssueTypeStatusAction,
  trackEvent,
  selectIssueTypeForEdit,
  showIssueTypesEditModalAction,
  showIssueTypesAddAttributesModalAction,
  showIssueTypesLeaveAddAttributesModalAction,
  updateRequiredFields
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypesAdmin);
